import React from "react";
import { PageHeader } from "@/components/header/header.it";
import WelcomeLoader from "../WelcomeLoader/WelcomeLoader";
import "./WaitingScreen.scss";

const WaitingRoom = () => {
  return (
    <>
      <div className="waiting-screen">
        <PageHeader />
        <div className="waiting-screen-content">
          <div className="welcomeloader-header">Veuillez patienter...</div>
          <WelcomeLoader />
          <div className="welcomeloader-text">
            Il tuo viaggio culturale inizia tra pochi istanti.
          </div>
        </div>
      </div>
    </>
  );
};
export default WaitingRoom;
